import styles from "./InvestorsCell.module.scss";
import { TCompany } from "../../../const/const";
import { Typography } from "@/frontend/shared/ui/Typography";

export function InvestorsCell({ field }: { field: TCompany["harmonicInvestors"] }) {
  const text = field
    ?.slice(0, 5)
    ?.map(({ name }) => name)
    ?.join(", ");
  // {index === 1 && field.length > 2 && <Tag size="small">+{`${field.length - 2}`}</Tag>}

  return (
    <div className={styles.container}>
      <Typography variant="label-4" color="greyscale900">
        {text}
      </Typography>
    </div>
  );
}
